import React, { useState } from "react";
import { Button, Dropdown, Space } from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  ReloadOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { fetchPipelines } from "./SkeyeingestPipelinesAPI";
import SkeyeingestPipelinesTable from "./SkeyeingestPipelinesTable";
import SkeyeingestCreatePipelineDialog from "./SkeyeingestCreatePipelineDialog";
import SkeyeingestImportPipelineDialog from "./SkeyeingestImportPipelineDialog";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import skeyeingestPipelinesHelp from "../../../content/help/skeyeingest-pipelines.json";

export default function SkeyeingestPipelines({
  pageTitle = "Skeyeingest Pipelines",
}) {
  usePageTitle("SkeyeIngest Pipelines - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchPipelines,
    filterFields: [
      "pipelineId",
      "title",
      "status",
      (p) => p.created?.toString(),
      (p) => p.lastModified?.toString(),
    ],
  });

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const isRoleUser = useIsRoleUser();

  const menuItems = [
    {
      key: "create",
      label: "Create Pipeline",
      icon: <PlusOutlined />,
      onClick: () => setCreateModalOpen(true),
    },
    {
      key: "import",
      label: "Import Pipeline",
      icon: <UploadOutlined />,
      onClick: () => setImportModalOpen(true),
    },
  ];

  return (
    <PageLayout
      title={pageTitle}
      logo="/img/majesteye-icon-skeye-ingest-square-white-background-no-label"
      description="Manager for Skeyeingest pipelines, allowing you to organize your pipelines in one place."
      helpContent={skeyeingestPipelinesHelp}
    >
      {contextHolder}
      <SearchToolbar
        search={searchText}
        onSearchChange={handleSearch}
        onClearFilter={clearFilter}
        showAdd={false}
        extra={
          <div style={{ marginLeft: "auto", display: "flex", gap: "10px" }}>
            <Button
              icon={<ReloadOutlined />}
              onClick={loadData}
              loading={loading}
              style={{ borderColor: "#0D2E4D", color: "#0D2E4D" }}
            >
              Refresh
            </Button>
            {!isRoleUser && (
              <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                <Button type="primary" style={{ backgroundColor: "#0D2E4D" }}>
                  <Space>
                    Actions <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            )}
          </div>
        }
      />
      <SkeyeingestPipelinesTable
        data={filteredData}
        loading={loading}
        page={page}
        pageSize={pageSize}
        onPageChange={onPageChange}
        messageApi={messageApi}
      />
      <SkeyeingestCreatePipelineDialog
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
      <SkeyeingestImportPipelineDialog
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
    </PageLayout>
  );
}
